import RejectConfirmDialog from "./rejectConfirmDialog.container";

export default RejectConfirmDialog;
